import classNames from 'classnames';
import React from 'react';
import * as styles from './PopOverArrow.module.scss';
import PopOverPrimitive from './PopOverPrimitive';

interface PopOverArrowProps {
  className?: string;
}

const PopOverArrow = ({ className }: PopOverArrowProps) => {
  return (
    <PopOverPrimitive.Arrow
      height={10}
      width={18}
      offset={2}
      viewBox="0 0 18 10"
      className={className}
    >
      <path
        className={styles.arrowBg}
        d="M9.95385 1.71898L17 9L1 9L8.53945 1.69616C8.93627 1.31174 9.56964 1.32196 9.95385 1.71898Z"
      />

      <path
        clipPath='path("M 0 8 L 18 8 L 18 0 L 0 0")'
        className={classNames(styles.arrowBg, styles.arrowStroke)}
        d="M17 9L9.95385 1.71898C9.56964 1.32196 8.93627 1.31174 8.53945 1.69616L1 9"
      />
    </PopOverPrimitive.Arrow>
  );
};

export default PopOverArrow;
